import { lazy } from 'react';

import { SuspenseWrapper } from 'components/suspense-wrappper';

const Element = lazy(() => import('./canvas-results-ntu'));

export const CanvasResultsNtuLazy = () => (
  <SuspenseWrapper>
    <Element />
  </SuspenseWrapper>
);
